let sessionToken = null;

export const setSessionToken = (token) => {
  sessionToken = token || null;
};

export const getSessionToken = () => sessionToken;

export const clearSessionToken = () => {
  sessionToken = null;
};
